function runEvents() {

  const nativeRechargeWidget = document.querySelector(".rc-container-wrapper.rc_container_wrapper");
  const variantSelects = document.querySelector(".product__info-wrapper variant-selects");

  //Return if recharge or variants aren't present for this product
  if(!nativeRechargeWidget || !variantSelects) return;

  moveAndUpdateWidget(nativeRechargeWidget, variantSelects);
}

function moveAndUpdateWidget(nativeRechargeWidget, variantSelects) {

  //Move recharge subscription div
  variantSelects.after(nativeRechargeWidget);

  //Update recharge SVG icon
  const popupButtonWrapper = nativeRechargeWidget.querySelector(".rc_popup_label_wrapper");
  const popupSVG = popupButtonWrapper.querySelector("svg");
        popupSVG.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-recharge-replacement reload-icon" width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M6.75 0.750977V2.25098H11.25V0.750977H12.75V2.25098H15.75C15.9489 2.25098 16.1397 2.32999 16.2803 2.47065C16.421 2.6113 16.5 2.80206 16.5 3.00098V15.001C16.5 15.1999 16.421 15.3907 16.2803 15.5313C16.1397 15.672 15.9489 15.751 15.75 15.751H2.25C2.05109 15.751 1.86032 15.672 1.71967 15.5313C1.57902 15.3907 1.5 15.1999 1.5 15.001V3.00098C1.5 2.80206 1.57902 2.6113 1.71967 2.47065C1.86032 2.32999 2.05109 2.25098 2.25 2.25098H5.25V0.750977H6.75ZM15 8.25098H3V14.251H15V8.25098ZM5.25 3.75098H3V6.75098H15V3.75098H12.75V5.25098H11.25V3.75098H6.75V5.25098H5.25V3.75098Z" fill="#28292A"/></svg>';

  //Prevent recharge default hover state
  //Instead add our own event listener to toggle modal
  const popupHoverTrigger = document.querySelector(".rc_popup__hover");
        popupHoverTrigger?.classList.remove("rc_popup__hover");
        popupHoverTrigger?.addEventListener("click", toggleCustomModal);
}

function toggleCustomModal() {

  const divChildren = Array.from(document.querySelector(".recharge-subscription__details")?.children)?.length;

  const rechargePopup = document.querySelector(".rc_popup__block__content");

  //Only run the build function if the modal is empty
  //Prevents duplicates from appearing if the modal is opened, closed, and then reopened again
  if(divChildren == 0) {
    buildCustomModal(rechargePopup);
  }

  //Show modal
  //Assign out closeModal listener for background overlay
  const customModal = document.querySelector(".recharge-subscription__custom-modal");
        customModal?.classList.remove("hidden");
        customModal?.addEventListener("click", (event) => {
          closeModal(event, customModal, body);
        });

  //Assign out closeModal listener for X icon
  const rechargeCloseIcon = document.getElementById("close-recharge-modal");
        rechargeCloseIcon?.addEventListener("click", (event) => {
          closeModal(event, customModal, body);
        });
        rechargeCloseIcon?.focus();

  //Prevent scrolling when modal is open
  const body = document.querySelector("body");
        body.classList.add("overflow-hidden");
}

function buildCustomModal(rechargePopup) {

  //Take all elements from native recharge popup and consolidate into one div for easier styling (firstRechargePopupElement)
  const arrayOfPopupChildren = Array.from(rechargePopup?.children);
  const firstRechargePopupElement = arrayOfPopupChildren[0];
  const otherRechargePopupElements = arrayOfPopupChildren?.slice(1);

  const lineBreak = document.createElement("br");

  if(otherRechargePopupElements) {
    otherRechargePopupElements?.forEach((element) => {

      firstRechargePopupElement?.appendChild(lineBreak);
      firstRechargePopupElement?.appendChild(element);
    });
  }

  //Append our consolidated element of recharge content to our custom modal
  const customModalDetails = document.querySelector(".recharge-subscription__details");
        customModalDetails?.appendChild(firstRechargePopupElement);
  
  //Create X Icon
  const customModalInner = document.querySelector(".recharge-subscription__inner");
        customModalInner.innerHTML += `<button tabindex="0" id="close-recharge-modal" class="close-recharge-modal" aria-label="${window.Resources.recharge.subscriptions.closeModal}"><svg xmlns="http://www.w3.org/2000/svg" class="icon icon-close-recharge-modal" width="21" height="21" viewBox="0 0 21 21" fill="none"><path d="M11.286 10.4992L15.8916 5.89368C16.0804 5.67326 16.0677 5.34468 15.8625 5.13948C15.6573 4.93427 15.3287 4.92158 15.1083 5.11035L10.5027 9.7159L5.89716 5.10479C5.67931 4.88694 5.32612 4.88694 5.10827 5.10479C4.89043 5.32264 4.89043 5.67583 5.10827 5.89368L9.71938 10.4992L5.10827 15.1048C4.94973 15.2406 4.88067 15.4537 4.92949 15.6567C4.97831 15.8596 5.13676 16.0181 5.33971 16.0669C5.54265 16.1157 5.75583 16.0467 5.8916 15.8881L10.5027 11.2826L15.1083 15.8881C15.3287 16.0769 15.6573 16.0642 15.8625 15.859C16.0677 15.6538 16.0804 15.3252 15.8916 15.1048L11.286 10.4992Z" fill="#707070"/></svg></button>`;
}

function closeModal(event, modal, body) {
  const eventTarget = event.target;

  if(
    eventTarget.classList.contains("recharge-subscription__custom-modal") ||
    eventTarget.classList.contains("close-recharge-modal") ||
    eventTarget.classList.contains("icon-close-recharge-modal")
  ) {
    modal.classList.add("hidden");
    body.classList.remove("overflow-hidden");
  }
}

function updateATCButtonPrice(mutationList) {

  if(mutationList.length == 0) return;

  const hidePrice = document.querySelector("[data-hide-price]")?.dataset?.hidePrice;
  const priceString = mutationList[0].target.querySelector(".price-item")?.innerHTML;
  const atcButton = document.querySelector(".product-form__submit > span");
  const atcButtonText = atcButton?.innerHTML.trim();

  //If hide ATC price is true, return
  //If variant is OOS, return
  //If variant selection hasnt been made yet, return
  if(
      hidePrice == "true" ||
      atcButtonText == window.variantStrings.promptSelection ||
      atcButtonText == window.variantStrings.soldOut
    )
  return;

  const atcPriceSplit = atcButtonText.split("- ")[1].trim();

  if(priceString != atcPriceSplit) {
    atcButton.textContent = window.variantStrings.addToCart + " - " + priceString;
  }
}